//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyLoad from 'vanilla-lazyload'

import { mapGetters } from 'vuex'
import { DESKTOP, MOBILE, TABLET } from '@/scripts/constants/media-query'
import Rb3dDynamicContent from './rb-3d-dynamic-content'
import Rb3dToggleProvider from './rb-3d-toggle-provider'
import Images from '@/scripts/libs/images'
import wcs from '@/scripts/libs/wcs'
import { EVENTS } from '@/scripts/constants/css-classes'

export default {
  name: 'rb-3d-carousel',
  components: {
    Rb3dDynamicContent,
    Rb3dToggleProvider,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'white',
    },
  },
  data() {
    return {
      currentTabId: 0,
      isLoading: true,
      skeletonIsVisible: true,
      imagesToLoad: [],
      activeDuplicateSlide: undefined,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    defaultConfig() {
      return {
        speed: 600,
        slidesPerView: 1.75,
        loop: true,
        centeredSlides: true,
        allowTouchMove: !this.skeletonIsVisible,
        touchStartPreventDefault: false,
        breakpoints: {
          768: {
            slidesPerView: 3,
            noSwiping: false,
            allowTouchMove: false,
          },
        },
      }
    },
    getSlidesPerView() {
      return this.isMobile ? '1.7' : '3'
    },
    getAllToggles() {
      return this.$slots.toggles?.filter((slot) => slot.tag) ?? []
    },
    numberOfToggles() {
      return this.getAllToggles.length
    },
    areTogglesVisible() {
      return this.numberOfToggles > 0
    },
    isTitleVisible() {
      return this.$slots.title
    },
    numberOfCurrentSlides() {
      return this.getCurrentTab?.children?.filter((child) => child.tag)?.length
    },
    getAllTabs() {
      return this.$slots.banners.filter((slot) => slot.tag)
    },
    getCurrentTab() {
      if (this.currentTabId) {
        return []
      } else {
        return this.getAllTabs[0]
      }
    },
  },
  watch: {
    getSlidesPerView(prev, next) {
      if (prev !== next) {
        this.reInitSwiper()
      }
    },
    skeletonIsVisible(prev, next) {
      if (prev !== next) {
        this.reInitSwiper()
      }
    },
  },
  mounted() {
    if (this.numberOfToggles > 1) {
      const firstToggle = this.getAllToggles[0]
      this.currentTabId = firstToggle?.componentOptions?.propsData?.id ?? 0
    } else {
      const toggle = this.getAllTabs[0]
      this.currentTabId = Number(toggle?.data?.attrs['data-toggle-id']) ?? 0
    }
  },
  beforeDestroy() {
    this.removeClickListenerOnActiveDuplicateSlide()
  },
  methods: {
    async onInit() {
      // TODO: remove once we successfully update swiper with afterInit callback
      setTimeout(() => {
        this.isLoading = false
      }, 200)
    },
    async onToggleClick(toggledId) {
      if (toggledId !== this.currentTabId) {
        this.isLoading = true
        this.currentTabId = toggledId
        this.reInitSwiper()
      }
    },
    reInitSwiper() {
      if (this.$refs.swiperRef?.swiper) {
        this.$refs.swiperRef.swiper.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
        })
      }
    },
    viewportEnter(event) {
      if (event.type === 'enter') {
        this.bulkLoadCarouselImages()
      }
    },
    retrieveImagesToLoad() {
      const attribute = this.mapNeededImageAttribute()

      return this.$slots.banners[0]?.children
        ?.filter((child) => child.tag)
        ?.map((child) => {
          if (child.data.attrs[attribute]) {
            return child.data.attrs[attribute]
          }
          const wcsProduct = child.componentOptions.propsData.wcsProduct
          const { pdp } = wcs.getStoreConfig()
          const productImage = `${pdp.imagesPath}${wcsProduct.partNumber}__STD__shad__cfr.png`
          return Images.get3dProductImage(this.$mq, productImage, this.backgroundColor)
        })
    },
    async bulkLoadCarouselImages() {
      const images = this.retrieveImagesToLoad()

      if (!images?.length) {
        this.skeletonIsVisible = false
        return
      }

      this.imagesToLoad = images
      await this.$nextTick()

      const options = {
        unobserve_entered: true,
        container: this.$refs.imagesToLoad,
        elements_selector: 'img, video',
        callback_loaded: () => {
          this.skeletonIsVisible = false
        },
      }
      const lazyLoader = new LazyLoad(options)
      lazyLoader.update()
    },
    mapNeededImageAttribute() {
      if (this.$mq === DESKTOP) {
        return 'image-desktop'
      } else if (this.$mq === TABLET) {
        return 'image-tablet'
      } else {
        return 'image-mobile'
      }
    },
    addClickListenerOnActiveDuplicateSlide() {
      const slides = this.$refs['slides']
      const activeDuplicateSlide = slides.querySelector(
        '.swiper-slide-duplicate.swiper-slide-active'
      )
      if (activeDuplicateSlide) {
        this.activeDuplicateSlide = activeDuplicateSlide
        activeDuplicateSlide.addEventListener(EVENTS.CLICK, this.triggerCtaOnBannerClick)
      } else {
        this.removeClickListenerOnActiveDuplicateSlide()
      }
    },
    triggerCtaOnBannerClick() {
      const cta = this.activeDuplicateSlide?.querySelector('.rb-btn')
      cta?.click()
    },
    removeClickListenerOnActiveDuplicateSlide() {
      this.activeDuplicateSlide &&
        this.activeDuplicateSlide.removeEventListener(EVENTS.CLICK, this.triggerCtaOnBannerClick)
      this.activeDuplicateSlide = undefined
    },
  },
}
